var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenMouth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 462.07 372.55",
    style: {
      enableBackground: "new 0 0 462.07 372.55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EB4966;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#F8BEAF;}\r\n\t.st3{fill:#F8C2B2;}\r\n\t.st4{fill:#2F1516;}\r\n\t.st5{fill:#F59B87;}\r\n\t.st6{fill:#151011;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.05,307.52c11.84-24.72,36.11-24,41.28-23.55c-1.91,4.84-4.72,9.09-7.34,13.35 c-11.38,18.51-25.54,31.99-39.59,41.77C154.59,334.38,153.75,324.85,162.05,307.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.55,199.6c0,2.55-2.06,4.61-4.61,4.61c-2.55,0-4.61-2.06-4.61-4.61c0-2.54,2.06-4.61,4.61-4.61 C138.48,194.99,140.55,197.05,140.55,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.08,170.56c0,0,25.85,14.45,16.73,22.81c-9.12,8.36-19.01-3.04-22.81-9.12 C132.2,178.16,133.72,165.99,142.08,170.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.02,185.09c0,0,21.95,12.26,14.2,19.37c-7.75,7.1-16.14-2.58-19.36-7.75 C126.62,191.54,127.92,181.22,135.02,185.09z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.92,224.92c0,19.36,21.68,19.14,32.85,17.07c-3.28-11.57-5.5-22.82-6.98-33.23 C49.7,208.17,30.92,208.2,30.92,224.92z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M379.75,160.71c-39.64-22.2-67.39,20.61-67.39,20.61l-11.89,26.16L264,205.1l11.1-49.15 c15.15-15.81,24.19-100.24-10.67-105.53c-60.5-9.19-206.45,78.07-206.45,78.07l-3.66,28.85c-0.48,8.87-0.87,28.01,2.47,51.43 c1.65,0.14,2.67,0.31,2.67,0.31s-1.02-0.17-2.67-0.31c1.48,10.41,3.7,21.66,6.98,33.23c0.72-0.13,1.4-0.28,2.03-0.42 c-0.63,0.14-1.31,0.28-2.03,0.42c5.56,19.62,14.17,40.15,27.39,59.02c0,0,54.83-33.28,82.49-54.03 c0,0,27.37,63.17-30.43,101.38c4.62,2.62,9.45,5.09,14.55,7.37c100.27,44.79,183.07-10.19,216.07-45.17l-5.19-3.19l8.72-19.03 l-22.2,18.24c0,0-28.54-23.78-30.13-53.91C390.06,254.25,419.39,182.9,379.75,160.71z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M449.51,106c-22.2-50.74-49.95-74.52-84.04-88C287.78-11.33,192.65-7.37,119.71,48.92 C46.77,105.21,35.68,121.07,0,115.52l52.86,15.39c0,0,212.42-116.38,222.24,25.04L264,205.1l36.47,2.38l11.89-26.16 c0,0,27.75-42.81,67.39-20.61c39.64,22.2,10.31,93.55-54.7,91.96c1.59,30.13,30.13,53.91,30.13,53.91l22.2-18.24l-8.72,19.03 l5.19,3.19c6.14-6.5,10.56-12.32,13.04-16.67c-2.49,4.35-6.91,10.17-13.04,16.67l15.42,9.49c26.96-11.1,46.77-50.74,57.08-72.14 C446.34,247.91,479.5,174.54,449.51,106z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M331.09,206.19c0,0,25.37-32.5,51.53-19.82C382.62,186.37,350.91,191.92,331.09,206.19z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 105.02,
    cy: 194.9,
    rx: 16.17,
    ry: 21.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.56,215.46c0,11.38-9.23,20.61-20.61,20.61c-11.38,0-20.61-9.23-20.61-20.61 c0-11.38,9.23-20.61,20.61-20.61C206.33,194.85,215.56,204.08,215.56,215.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.18,203.66c0,3.03,2.46,5.49,5.49,5.49c3.03,0,5.49-2.46,5.49-5.49c0-3.03-2.46-5.5-5.49-5.5 C101.64,198.16,99.18,200.63,99.18,203.66z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenMouth);
export default __webpack_public_path__ + "static/media/openMouth.482b649eb957d45c850e01e18d5c7d97.svg";
export { ForwardRef as ReactComponent };